import React from "react";
import "./Footer.css"

export default function Footer(){
    return(
        <footer>
          <em>
            {" "}
            <a href="https://github.com/gabrieladora/gabriela-react-app" target="_blank" rel="noopener noreferrer" className="font-link">
              Open-source code
            </a>{" "}
            by Gabriela-Dora
          </em>
        </footer>   
    )
}